<p style="margin: auto; display: block; text-align: center; margin-top: 40px">
  {{ error }}
</p>
